import axios from 'axios';

import { Helpers } from '../helpers/Helpers';
import { AddServiceRequest } from '../models/request/service/AddServiceRequest';
import { GetServiceListPagingAndFilterRequest } from '../models/request/service/GetServiceListPagingAndFilterRequest';

export class ServiceService {
    static async getServiceList(_isIncome: boolean | undefined, _serviceIncomeTypes: string[] | undefined = undefined) {
        try {
            var inputObj = {
                isIncome: _isIncome,
                serviceIncomeTypes: _serviceIncomeTypes
            };

            console.log('SERVICE CALL - getServiceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Service/getServiceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportServiceList(inputObj: GetServiceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportServiceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Service/exportServiceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getServiceListPagingAndFilter(inputObj: GetServiceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetServiceListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Service/GetServiceListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addService(inputObj: AddServiceRequest) {
        try {
            console.log('SERVICE CALL - AddService', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Service/AddService', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteService(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteService', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Service/deleteService', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getServiceById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getServiceById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Service/getServiceById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}